export default "__VITE_ASSET__910e1dd6__"